
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "@/store/httpClient";
const Chart = require("chart.js");

@Component
export default class ComplainRateReport extends Vue {
	private chart: any = null;
	private complainRates: any = [];
	private loading: boolean = false;
	private mounted() {
		this.loadReport();
	}

	private async loadReport() {
		try {
			this.loading = true;
			const response = await httpClient().get(`Report/GetComplainRate`);
			this.complainRates = response.data;
			this.updateDiagram();
		} catch (err) {
			console.error("Loading evaluation reports failed.");
			console.error(err);
			this.$store.commit(
				"setSnackbarErrorText",
				"Fehler beim Laden der Reports. Siehe Konsole."
			);
		} finally {
			this.loading = false;
		}
	}

	private getDatasets() {
		const colors = [
			"#635147",
			"#EFBB20",
			"#704214",
			"#468641",
			"#A3FF00",
			"#00F4C4",
			"#123524",
			"#007EFF",
			"#005A99",
			"#4B0082",
			"#A146FF",
			"#FF0090",
			"#FF2400",
		];
		var datasets = [];
		var i = 0;
		for (const complain of this.complainRates) {
			var referenceData = complain.fertigerComplainRates.map(
				(c: any) => c.complainRateInProcent
			);

			datasets.push({
				label: complain.fertigerName, // Label shown above the graph
				borderColor: colors[i], // Color of the line
				pointHitRadius: 2, // Size of the area where the point reacts to the mouse
				fill: false,
				tension: 0.3, // How "smooth" the line is. 0 for straight lines
				data: referenceData,
			});
			i++;
		}
		return datasets;
	}

	private updateDiagram() {
		const labels = this.complainRates[0].fertigerComplainRates.map((f: any) => `${f.year}`);

		// Destroy the chart if one already exists.
		if (this.chart != null) {
			this.chart.destroy();
		}

		const ctx = (this.$refs.diagramCanvas as any).getContext("2d");
		this.chart = new Chart(ctx, {
			// The type of chart we want to create
			type: "line",
			// The data for our dataset
			data: {
				labels,
				datasets: this.getDatasets(),
			},
			// Configuration options go here
			options: {
				tooltips: {
					callbacks: {
						label: function (tooltipItem: any, data: any): any {
							var procent = tooltipItem.yLabel;
							var fertiger = data.datasets[tooltipItem.datasetIndex].label;
							return `${fertiger}: ${procent.toFixed(2).toString()}%`;
						},
					},
				},
			},
		});
		this.chart.update();
	}
}
